import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ profileId = '', ...params }) => {
  return await dponetAPI.get(`/profiles/${profileId}`, { params })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/profiles', data)
}

const edit = async ({ profileId = '', ...data }) => {
  return await dponetAPI.put(`/profiles/${profileId}`, data)
}

const changeStatus = async (profileId) => {
  return await dponetAPI.put(`/profiles/${profileId}/change_status`)
}

export default { get, create, edit, changeStatus }
